import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { IMPORT_SURVEYS } from './constants';
import {
  ImportSurveysDataActionTypes,
  ImportSurveysError,
  ImportSurveysState,
  ImportSurveysSuccess,
} from './types';

const initialState: ImportSurveysState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: ImportSurveysDataActionTypes,
  ): ImportSurveysState => {
    switch (action.type) {
      case IMPORT_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case IMPORT_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as ImportSurveysSuccess).payload;
        break;
      }
      case IMPORT_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as ImportSurveysError).error;
        break;
      }
      case IMPORT_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
